import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from '../../../QestIds';
import { PreparationSection } from '../Shared';
import { DryMassSection, WashingSection } from './Sections';
import { ResultsSection } from './Sections/ResultsSection';

const qestIds = [ids.wash.ASTM_C117.rev2017, ids.wash.AASHTO_T_11.rev2020];

const WashAstmC117Worksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <PreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <DryMassSection />
      <WashingSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <ResultsSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

WashAstmC117Worksheet.qestIds = qestIds;

export { WashAstmC117Worksheet };
